import React,{Component} from 'react';
import {Link} from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import Skeleton from '@material-ui/lab/Skeleton';
import CheckListIconWhite from '../../../images/check-list-white.png';
import iconNewW from '../../../images/blue-2.png';
import iconNewM from '../../../images/blue-3.png';
import iconReport from '../../../images/icon-3.png';
import iconApproval from '../../../images/icon-4.png';
import user from "../../../images/user.png";

import Api from "../../../libraries/api";
import moment from "moment/moment";

import AuthHelper from "../../../libraries/auth-helper";

class Home extends Component {
    constructor(props) {

        super(props);
        this.state = {
            loading: false,
            loading1: false,
            loading2: false,
            loading3: false,
            loading4: false,
            loading5: false,
            loading6: false,
            loading7: false,
            loading8: false,
            loading9: false,
            loading10: false,
            loading11: false,
            loading12: false,

            data1: 0,
            data2: '',
            data3: '',
            data4: '',
            data5: '',
            data6: 0,
            data7: 0,
            data8: 0,
            data9: 0,
            data10: 0,
            data11: 0,
            data12a: 0,
            data12b: 0,

            rows: [],
            total: 0,
            perPage: 10,
            currentPage: 1,
            currentPageTable: 0,
        }
    }

    componentDidMount() {
        document.title = 'Abadi - Dashboard';

        this.setState({
            loading: true,
            loading1: true,
            loading2: true,
            loading3: true,
            loading4: true,
            loading5: true,
            loading12: true,
        });

        this.__fetchData(false);

        Api.get('/dashboards/project-comment-seven-days').then(resp => {

            if (resp.data.length > 0) {
                this.setState({
                    data1: resp.data[0].total,
                    loading1: false
                })

            }

        }).catch(err => {
            console.log(err);
            this.setState({
                loading1: false
            })
        });

        Api.get('/projects?numberOfDays=true').then(resp => {

            if (resp.data.length > 0) {
                this.setState({
                    data2: resp.data.length,
                    loading2: false
                })

            }

        }).catch(err => {
            console.log(err);
            this.setState({
                loading2: false
            })
        });


        Api.get('/dashboards/case-this-month').then(resp => {

            if (resp.data.length > 0) {
                this.setState({
                    data7: resp.data[0].total,
                    loading7: false
                })

            }

        }).catch(err => {
            console.log(err);
            this.setState({
                loading7: false
            })
        });

        Api.get('/dashboards/issue-report-week').then(resp => {

            if (resp.data.length > 0) {
                this.setState({
                    data8: resp.data[0].total,
                    loading8: false
                })

            }

        }).catch(err => {
            console.log(err);
            this.setState({
                loading8: false
            })
        });

        Api.get('/dashboards/issue-report-month').then(resp => {

            if (resp.data.length > 0) {
                this.setState({
                    data9: resp.data[0].total,
                    loading9: false
                })

            }

        }).catch(err => {
            console.log(err);
            this.setState({
                loading9: false
            })
        });

        Api.get('/dashboards/count-report').then(resp => {

            if (resp.data.length > 0) {
                this.setState({
                    data10: resp.data[0].total,
                    loading10: false
                })

            }

        }).catch(err => {
            console.log(err);
            this.setState({
                loading10: false
            })
        });

        Api.get('/dashboards/count-approval').then(resp => {

            if (resp.data.length > 0) {
                this.setState({
                    data11: resp.data[0].total,
                    loading11: false
                })

            }

        }).catch(err => {
            console.log(err);
            this.setState({
                loading11: false
            })
        });

        Api.get('/dashboards/follow-up').then(resp => {

            if (resp.data) {
                this.setState({
                    data12a: resp.data.report,
                    data12b: resp.data.approval,
                    loading12: false
                })

            }

        }).catch(err => {
            console.log(err);
            this.setState({
                loading12: false
            })
        });

        this.setState({
            userData: AuthHelper.getProfile(),
        });
    }

    __fetchData = update => {
        this.setState({
            loading: true,
        });
        let page = update ? parseInt(this.state.currentPage + 1) : this.state.currentPage;

        let sort = this.state.orderBy ? '&orderBy=' + this.state.orderBy + '&sortedBy=' + this.state.sortedBy : '';
        let search = this.state.searchBy ? '&search=' + this.state.searchBy : '';

        let route = '';

        if(search) {
            route = '/comments?include=project&sortedBy=desc&orderBy=created_at&limit='+this.state.perPage+sort+search;
        }else {
            route = '/comments?include=project&sortedBy=desc&orderBy=created_at&limit='+this.state.perPage+'&page='+page+sort+search;
        }

        Api.get(route).then(resp => {
            if (resp.data) {
                let data = this.state.rows;
                Array.prototype.push.apply(data,resp.data);

                console.log(data);
                this.setState({
                    rows: data,
                    perPage: resp.meta.pagination.per_page,
                    currentPage: resp.meta.pagination.current_page,
                    currentPageTable: resp.meta.pagination.current_page - 1,
                    total: resp.meta.pagination.total,
                    loading: false,
                    isEdit: resp.meta.custom.isEdit,
                    isDelete: resp.meta.custom.isDelete,
                    isCreate: resp.meta.custom.isCreate,
                })

            }
        }).catch(err => {
            console.log(err);
        });
    };

    handleChangePage = () => {
        this.setState({
            loading: true,
        }, () => {
            this.__fetchData(true);
        });
    };

    filterStatus = (name) => {
        let text = '';

        switch(name) {
            case 'Follow Up':
                text = 'yellow';
                break;
            case 'On Progress':
                text = 'blue';
                break;
            case 'Finish':
                text = 'purple';
                break;
            case 'Completed':
                text = 'green';
                break;
            case 'Cancel':
                text = 'red';
                break;
            case 'Pending':
                text = 'yellow';
                break;
            case 'Partial Payment':
                text = 'green';
                break;
            case 'Complete Payment':
                text = 'blue';
                break;
            default:
                text = 'yellow';
        }
        
        return text;
    };

    renderFloatingButtonPersonalProject = () => {
        let redirectUrl = `/projects-filter?commentSevenDays=true`
        redirectUrl += `&adminId=${this.state.userData?.id}`;
        redirectUrl += `&surveyorId=${this.state.userData?.id}`;
        redirectUrl += `&finalReviewerId=${this.state.userData?.id}`;
        
        return (
            <Link to={redirectUrl} target='_blank'>
                <Tooltip title="Pergi ke Personal Need to be Updated Project" arrow>
                    <Fab className="fab-need-to-update" color="secondary" >
                        <img src={CheckListIconWhite} alt='todo' width={35} />
                    </Fab>
                </Tooltip>
            </Link>
        );
    };

    renderFloatingButtonMyTask = () => {
        let redirectUrl = '/my';
        
        return (
            <Link to={redirectUrl} target='_blank'>
                <Tooltip title="Pergi ke My Task" arrow>
                    <Fab className="fab-my-task" color="secondary" >
                        <img src={CheckListIconWhite} alt='todo' width={35} />
                    </Fab>
                </Tooltip>
            </Link>
        );
    };

    render() {

        return (
            <div className="row main-content">

                {/* {this.renderFloatingButtonPersonalProject()} */}
                {this.renderFloatingButtonMyTask()}

                <div className="col-12 px-lg-5">
                    <h2 className="page-title">AIS Timeline Updates</h2>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                        </ol>
                    </nav>
                    <div className="row mt-4">
                        <div className='col-md-9 '>
                            <div className='comment-wrap home'>

                                <div className='comment-container'>
                                    { 
                                        // this.state.loading ?
                                        // <div className='row mb-2'>
                                        //     <div className='col img-avatar'>
                                        //         <Skeleton variant='circle' width={60} height={60} />
                                        //     </div>
                                        //     <div className='col'>
                                        //         <Skeleton variant='text' />
                                        //         <Skeleton variant='text' />
                                        //     </div>
                                        // </div> :
                                        // this.state.rows.length === 0 ?
                                        //     <div className='col img-avatar mb-2'>
                                        //         <p>no comment</p>
                                        //     </div>
                                        //     :
                                            this.state.rows.map(row => (
                                                <div className='comment-list row pt-3' key={row.id}>
                                                    <div className='col img-avatar'>
                                                        <img src={row.user ? row.user.avatar !== null ? process.env.REACT_APP_API_STORAGE_PATH+row.user.avatar : user : user} alt='avatar' className='img-fluid' />
                                                    </div>
                                                    <div className='col-md-10'>
                                                        <h4>{row.user ? row.user.name : ''}</h4>
                                                        <p className='comment'>
                                                            <strong>Updates/comment:</strong> {row.comment}</p>
                                                        <time>{moment(row.created_at).format('DD MMM YYYY HH:mm:ss')}</time>
                                                        {row.image &&
                                                        <img
                                                            src={process.env.REACT_APP_API_STORAGE_PATH + row.image}
                                                            alt='avatar' className='img-fluid'/>
                                                        }
                                                    </div>
                                                    <div className='col-12 mt-3 pb-3'>
                                                        <div className='row'>
                                                            <div className='col-6 col-md-4'>
                                                                <p>
                                                                    <strong className='d-block'>Case/Project number:</strong>
                                                                <Link to={ + row.project.data.length > 0 ? '/projects/detail/'+row.project.data[0].id : '/'} target='_blank'>
                                                                    {row.project.data.length > 0 ? row.project.data[0].caseNumber : ''}{row.project.data.length > 0 ? '['+row.project.data[0].projectNumber+']' : ''}
                                                                </Link>
                                                                </p>
                                                                <p>
                                                                    <strong className='d-block'> Type:</strong>
                                                                    {row.project.data.length > 0 ? row.project.data[0].type : ''} - {row.project.data.length > 0 ? row.project.data[0].detailType : ''}
                                                                </p>


                                                            </div>
                                                            <div className='col-6 col-md-4'>
                                                                <p>
                                                                    <strong className='d-block'>Vessel:</strong> {row.project.data.length > 0 ? row.project.data[0].vesselName : ''}
                                                                </p>
                                                                <p><strong className='d-block'>Underwriter:</strong>
                                                                    {
                                                                        row?.project?.data?.length > 0 &&
                                                                        row?.project?.data?.[0]?.underWriters?.length > 0 &&
                                                                        row?.project?.data?.[0]?.underWriters?.map((option, id) => (
                                                                            <span className='d-block' key={id}>- {option?.name}</span>
                                                                        ))
                                                                    }
                                                                </p>
                                                                <p>
                                                                    <strong className='d-block'>Casualty:</strong> {row.project.data.length > 0 && row.project.data[0].casualty !== null ? row.project.data[0].casualty.substring(0, 20)+'...' : ''}
                                                                </p>
                                                            </div>
                                                            <div className='col-6 col-md-4'>

                                                                <p>
                                                                    <strong className='d-block'>Project Status:</strong>
                                                                    <span className={'label-status d-inline-block label-'+this.filterStatus(row.project.data.length > 0 ? row.project.data[0].projectStatusBar : '')}>{row.project.data.length > 0 ? row.project.data[0].projectStatusBar : ''}</span>

                                                                </p>
                                                                <p>
                                                                    <strong className='d-block'>Survey Status:</strong>
                                                                    <span className={'label-status d-inline-block label-'+this.filterStatus(row.project.data.length > 0 ? row.project.data[0].surveyStatus : '')}>{row.project.data.length > 0 ? row.project.data[0].surveyStatus : ''}</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                    }
                                    <div className='text-center'>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className=""
                                            disabled={this.state.loading}
                                            onClick={this.handleChangePage}
                                        >
                                            Load More { this.state.loading && <i className="fa fa-spinner fa-spin"> </i> }
                                        </Button>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <h3 className='title-wrap'>PROJECT SUMMARY</h3>
                            {/* <Link to="/projects-filter?commentSevenDays=true" target='_blank'>
                                <div className="card-info yellow">
                                    <div className="row align-items-center">
                                        <div className="col-3 pr-0">
                                            <div className="wrap square">
                                                <img src={iconApproval} alt='dashboard' className="img-icon" />
                                            </div>
                                        </div>
                                        <div className="col-8 col-md-10 col-xl-8">
                                            <label className="label-grey">Need To Be Update</label>
                                            {
                                                this.state.loading1 ?
                                                    <Skeleton variant="text" /> :
                                                    <p className="number">{this.state.data1}</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Link> */}
                            <Link to="/projects-filter?numberOfDays=true" target='_blank'>
                                <div className="card-info yellow">
                                    <div className="row align-items-center">
                                        <div className="col-3 pr-0">
                                            <div className="wrap square">
                                                <img src={iconApproval} alt='dashboard' className="img-icon" />
                                            </div>
                                        </div>
                                        <div className="col-8 col-md-10 col-xl-8">
                                            <label className="label-grey">Case more than 3 Months</label>
                                            {
                                                this.state.loading2 ?
                                                    <Skeleton variant="text" /> :
                                                    <p className="number">{this.state.data2}</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Link>
                            <Link to="/projects-filter?typeId=647bbf15-c72a-4cdc-bace-464c5368e325&status=onp" target='_blank'>
                                <div className="card-info green">
                                    <div className="row align-items-center">
                                        <div className="col-3 pr-0">
                                            <div className="wrap square">
                                                <img src={iconReport} alt='dashboard' className="img-icon" />
                                            </div>
                                        </div>
                                        <div className="col-8 col-md-10 col-xl-8">
                                            <label className="label-grey">Report</label>
                                            {
                                                this.state.loading10 ?
                                                    <Skeleton variant="text" /> :
                                                    <p className="number">{this.state.data10}</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Link>
                            <Link to="/projects-filter?typeId=80e0e031-4932-466d-93c5-107ffd361218&status=onp" target='_blank'>
                                <div className="card-info green">
                                    <div className="row align-items-center">
                                        <div className="col-3 pr-0">
                                            <div className="wrap square">
                                                <img src={iconApproval} alt='dashboard' className="img-icon" />
                                            </div>
                                        </div>
                                        <div className="col-8 col-md-10 col-xl-8">
                                            <label className="label-grey">Approval</label>
                                            {
                                                this.state.loading11 ?
                                                    <Skeleton variant="text" /> :
                                                    <p className="number">{this.state.data11}</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Link>
                            <Link to="/projects-filter?typeId=647bbf15-c72a-4cdc-bace-464c5368e325&status=fol" target='_blank'>
                                <div className="card-info yellow">
                                    <div className="row align-items-center">
                                        <div className="col-3 pr-0">
                                            <div className="wrap">
                                                <img src={iconReport} alt='dashboard' className="img-icon" />
                                            </div>
                                        </div>
                                        <div className="col-8 col-md-10 col-xl-8">
                                            <label className="label-grey">Follow Up Report</label>
                                            {
                                                this.state.loading12 ?
                                                    <Skeleton variant="text" /> :
                                                    <p className="number">{this.state.data12a}</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Link>
                            <Link to="/projects-month" target='_blank'>
                                <div className="card-info blue">
                                    <div className="row align-items-center">
                                        <div className="col-3 pr-0">
                                            <div className="wrap">
                                                <img src={iconNewM} alt='dashboard' className="img-icon" />
                                            </div>
                                        </div>
                                        <div className="col-8 col-md-10 col-xl-8">
                                            <label className="label-grey">New Case This Month</label>
                                            {
                                                this.state.loading7 ?
                                                    <Skeleton variant="text" /> :
                                                    <p className="number">{this.state.data7}</p>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </Link>
                            <Link to="/issued" target='_blank'>
                                <div className="card-info blue">
                                    <div className="row align-items-center">
                                        <div className="col-3 pr-0">
                                            <div className="wrap">
                                                <img src={iconNewW} alt='dashboard' className="img-icon" />
                                            </div>
                                        </div>
                                        <div className="col-8 col-md-10 col-xl-8">
                                            <label className="label-grey">Issued This Month</label>
                                            {
                                                this.state.loading9 ?
                                                    <Skeleton variant="text" /> :
                                                    <p className="number">{this.state.data9}</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Link>
                            <Link to="/projects-filter?typeId=80e0e031-4932-466d-93c5-107ffd361218&status=fol" target='_blank'>
                                <div className="card-info yellow">
                                    <div className="row align-items-center">
                                        <div className="col-3 pr-0">
                                            <div className="wrap">
                                                <img src={iconApproval} alt='dashboard' className="img-icon" />
                                            </div>
                                        </div>
                                        <div className="col-8 col-md-10 col-xl-8">
                                            <label className="label-grey">Follow Up Approval</label>
                                            {
                                                this.state.loading12 ?
                                                    <Skeleton variant="text" /> :
                                                    <p className="number">{this.state.data12b}</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default Home;